import React from 'react';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

const deployments = [
  { id: 1, environment: 'Production', version: 'v1.2.3', status: 'Healthy', lastUpdated: '2023-05-15 10:30 AM' },
  { id: 2, environment: 'Staging', version: 'v1.2.4', status: 'Warning', lastUpdated: '2023-05-14 3:45 PM' },
  { id: 3, environment: 'Development', version: 'v1.3.0-beta', status: 'Error', lastUpdated: '2023-05-15 9:15 AM' },
  { id: 4, environment: 'QA', version: 'v1.2.3', status: 'Healthy', lastUpdated: '2023-05-13 11:20 AM' },
];

const statusChip = (status) => {
  switch (status) {
    case 'Healthy':
      return <Chip icon={<CheckCircleIcon />} label={status} color="success" size="small" />;
    case 'Warning':
      return <Chip icon={<WarningIcon />} label={status} color="warning" size="small" />;
    case 'Error':
      return <Chip icon={<ErrorIcon />} label={status} color="error" size="small" />;
    default:
      return <Chip label={status} size="small" />;
  }
};

const DeploymentDashboard = () => {
  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Deployment Dashboard</Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Environment</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Last Updated</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deployments.map((deployment) => (
              <TableRow key={deployment.id}>
                <TableCell>{deployment.environment}</TableCell>
                <TableCell>{deployment.version}</TableCell>
                <TableCell>{statusChip(deployment.status)}</TableCell>
                <TableCell>{deployment.lastUpdated}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default DeploymentDashboard;
